import { createFocusTrap } from "focus-trap";

const BACKGROUND_SELECTOR = "main, [role='main'], .container";

function hideBackground(modal) {
  document.querySelectorAll(BACKGROUND_SELECTOR).forEach((el) => {
    if (!modal.contains(el) && !el.contains(modal)) {
      if (!el.hasAttribute("data-modal-aria-hidden")) {
        var original = el.getAttribute("aria-hidden");
        el.dataset.modalAriaHidden = original === null ? "none" : original;
      }
      el.setAttribute("aria-hidden", "true");
    }
  });
}

function restoreBackground() {
  document.querySelectorAll("[data-modal-aria-hidden]").forEach((el) => {
    var original = el.dataset.modalAriaHidden;
    if (original === "none") {
      el.removeAttribute("aria-hidden");
    } else {
      el.setAttribute("aria-hidden", original);
    }
    delete el.dataset.modalAriaHidden;
  });
}

// Disable Bootstrap's built-in enforceFocus to prevent conflict with focus-trap
$.fn.modal.Constructor.prototype._enforceFocus = function () {};

$(document).on("shown.bs.modal", ".modal", function (e) {
  this._previouslyFocused = e.relatedTarget || document.activeElement;
  hideBackground(this);

  var autofocusEl = this.querySelector("[data-autofocus]");

  this._focusTrap = createFocusTrap(this, {
    initialFocus: autofocusEl || this,
    fallbackFocus: this,
    escapeDeactivates: false,
    allowOutsideClick: true,
  });
  this._focusTrap.activate();
});

$(document).on("hidden.bs.modal", ".modal", function () {
  if (this._focusTrap) {
    this._focusTrap.deactivate({ returnFocus: false });
    this._focusTrap = null;
  }
  restoreBackground();
  if (this._previouslyFocused && this._previouslyFocused.focus) {
    this._previouslyFocused.focus();
    this._previouslyFocused = null;
  }
});
